import { required, requiredDisabled } from "@corporate-tailwind/corp-form";

export class ContactBase {
  id: number | null = null;
  surname: string | null = null;
  name: string | null = null;
  email: string | null = null;
  phone: string | null = null;
  dateCreation: Date | null = null; 
  message: string | null = null;
  languageCode: string | null = null;
}

export class ContactDto extends ContactBase {

  
  static schema = {
    id:                 { type: Number, builderOption: requiredDisabled },
    surname:            { type: String, builderOption: required },
    name:               { type: String, builderOption: required },
    email:              { type: String, builderOption: required },
    phone:              { type: String, builderOption: required },
    dateCreation:       { type: String, builderOption: required },
    message:            { type: String, builderOption: required },
    languageCode:       { type: String, builderOption: required }

  };
}